export function debounce(callback, wait, immediate = false) {
    let timeout = null

    return function() {
        const callNow = immediate && !timeout
        const next = () => callback.apply(this, arguments)

        clearTimeout(timeout)
        timeout = setTimeout(next, wait)

        if (callNow) next()
    }
}

export function throttle(callback, wait, immediate = false) {
    let latestCall = new Date().getTime()

    return function() {
        let diff = new Date().getTime() - latestCall
        if (diff > wait) {
            callback.apply(this.arguments)
            latestCall = new Date().getTime()
        }

        // const callNow = immediate && initialCall
        // const next = () => {
        //     callback.apply(this, arguments)
        //     timeout = null
        // }

        // if (callNow) {
        //     initialCall = false
        //     next()
        // }

        // if (!timeout) {
        //     timeout = setTimeout(next, wait)
        // }
    }
}

export function sortBy(coleção, callback) {
    return (coleção || []).concat().sort((a, b) => {
        let aVal = callback(a)
        let bVal = callback(b)

        if (aVal < bVal) return -1
        if (aVal > bVal) return 1
        return 0
    })
}

export function sortByDesc(coleção, callback) {
    return (coleção || []).concat().sort((a, b) => {
        let aVal = callback(a)
        let bVal = callback(b)

        if (aVal < bVal) return 1
        if (aVal > bVal) return -1
        return 0
    })
}
